export const LIGHT_LOGO_PATH = 'images/logo.svg'

export const DARK_LOGO_PATH = 'images/logo_dark.svg'
